import { render, staticRenderFns } from "./ApplicantsFetching.vue?vue&type=template&id=2271703b"
import script from "./ApplicantsFetching.vue?vue&type=script&lang=js"
export * from "./ApplicantsFetching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports